import React, { useEffect, useState } from "react";
import { Users, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Dashboard card: student adds a parent's email for a weekly Monday progress update.
export const ParentEmailCard = () => {
  const [saved, setSaved] = useState(undefined);
  const [confirmed, setConfirmed] = useState(true);
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/me/parent-email").then(({ data }) => { setSaved(data.email); setConfirmed(data.confirmed); setVal(data.email || ""); }).catch(() => setSaved(null)); }, []);
  const save = async (email) => {
    setBusy(true);
    try {
      const { data } = await api.put("/me/parent-email", { email: email || null });
      setSaved(data.email); setConfirmed(data.confirmed); setVal(data.email || "");
      toast.success(!data.email ? "Parent updates turned off" : data.confirmed ? "Saved" : "We've emailed your parent a link to confirm");
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(Array.isArray(d) ? "Please enter a valid email address" : d || "Please check the email");
    }
    finally { setBusy(false); }
  };
  if (saved === undefined) return null;
  return (
    <section className="mt-10 rounded-3xl border border-border bg-card p-6" data-testid="parent-email-card">
      <h2 className="flex items-center gap-2 font-serif text-2xl"><Users size={20} className="text-primary" /> Weekly update for a parent</h2>
      <p className="mt-1 text-sm text-muted-foreground">Add a parent's email and they'll get a short update every Monday morning: practice days ticked off, lessons completed and quiz scores. They'll be asked to confirm first, and can unsubscribe any time.</p>
      <form onSubmit={(e) => { e.preventDefault(); save(val.trim()); }} className="mt-4 flex flex-wrap gap-2">
        <input type="email" value={val} onChange={(e) => setVal(e.target.value)} placeholder="parent@example.com" data-testid="parent-email-input"
          className="min-w-0 flex-1 rounded-full border border-border bg-background px-4 py-2 text-sm focus:border-primary focus:outline-none" />
        <button type="submit" disabled={busy || !val.trim() || val.trim().toLowerCase() === saved} data-testid="parent-email-save"
          className="inline-flex items-center gap-1.5 rounded-full bg-primary px-5 py-2 text-sm font-semibold text-primary-foreground disabled:opacity-50">
          {busy && <Loader2 size={14} className="animate-spin" />} Save
        </button>
        {saved && <button type="button" onClick={() => save(null)} disabled={busy} data-testid="parent-email-remove" className="rounded-full border border-border px-4 py-2 text-sm">Stop updates</button>}
      </form>
      {saved && confirmed && <p className="mt-2 text-xs text-muted-foreground" data-testid="parent-email-status">Updates go to {saved} every Monday.</p>}
      {saved && !confirmed && (
        <p className="mt-2 text-xs text-muted-foreground" data-testid="parent-email-pending">
          Waiting for {saved} to confirm. Updates start once they click the link in our email.
          <button type="button" onClick={() => save(saved)} disabled={busy} data-testid="parent-email-resend" className="ml-2 font-semibold text-primary hover:underline">Resend email</button>
        </p>
      )}
    </section>
  );
};
